
const TableDeliveryIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2473_206)">
                <path d="M21.4141 12.0416H2.58594C2.26234 12.0416 2 12.304 2 12.6276V15.138C2 15.4616 2.26234 15.7239 2.58594 15.7239H3.25523V21.414C3.28406 22.1906 4.39855 22.19 4.42711 21.414V15.7239H19.5729V21.414C19.6017 22.1906 20.7162 22.19 20.7448 21.414V15.7239H21.4141C21.7377 15.7239 22 15.4615 22 15.138V12.6275C22 12.304 21.7377 12.0416 21.4141 12.0416Z" fill="var(--react-select-text)" />
                <path d="M8.86194 8.82027H15.138C15.4615 8.82027 15.7239 8.55792 15.7239 8.23433C15.7239 6.38027 14.3619 4.83851 12.5859 4.5566V2.58589C12.5571 1.80929 11.4426 1.80988 11.414 2.58589V4.5566C9.63803 4.83851 8.276 6.38027 8.276 8.23433C8.276 8.55792 8.53834 8.82027 8.86194 8.82027Z" fill="var(--react-select-text)" />
            </g>
            <defs>
                <clipPath id="clip0_2473_206">
                    <rect width="20" height="20" fill="var(--react-select-text)" transform="translate(2 2)" />
                </clipPath>
            </defs>
        </svg>

    )
};
export default TableDeliveryIcon;